import { ChangeDetectorRef, Component } from '@angular/core';

import { EmailAiConfirmDialogResult } from '@core/email-ai-types';
import { TranslatePipe } from '@core/i18n-legacy';
import {
  CheckboxComponent,
  ConfirmDialogComponent,
  ConfirmDialogVariant,
  type DialogComponentI,
} from '@core/user-interface-legacy';

@Component({
  selector: 'rt-email-ai-confirm-dialog',
  imports: [ConfirmDialogComponent, TranslatePipe, CheckboxComponent],
  template: `
    <rt-confirm-dialog
      [title]="'app.redactor_inserts.ai_writer.confirm_dialog.title' | translate"
      [message]="'app.redactor_inserts.ai_writer.confirm_dialog.message' | translate"
      [agreeLabel]="'app.common.dismiss' | translate"
      [cancelLabel]="'app.common.cancel' | translate"
      [variant]="ConfirmDialogVariant.Warning"
      [triggerUpdateOnInit]="true"
      [isCancelable]="true"
      [closePayload]="{ payload: { dontShowAgain: this.dontShowAgain } }"
    >
      <rt-checkbox [checked]="dontShowAgain" (valueChange)="setDontShowAgain($event)" padding-top>
        <span text-weight-semi-bold>{{ 'app.common.dont_show_again' | translate }}</span>
      </rt-checkbox>
    </rt-confirm-dialog>
  `,
})
export class EmailAiConfirmDialogComponent
  implements DialogComponentI<void, EmailAiConfirmDialogResult>
{
  public ConfirmDialogVariant: typeof ConfirmDialogVariant = ConfirmDialogVariant;
  public dontShowAgain: boolean = false;

  constructor(private cdRef: ChangeDetectorRef) {}

  public setDontShowAgain($event: string | boolean) {
    this.dontShowAgain = !!$event;
    this.cdRef.detectChanges();
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  public setDialogData(data: any, triggerUpdate: boolean): void {}
}
